// @ts-ignore
export const start = (state, { message, color }) => {
  state.color = color;
  state.message = message;
  state.active = true;
};

// @ts-ignore
export const stop = (state) => {
  state.active = false;
};
